import React from 'react'
import TfidbTags from '../../Movie/TfidbTags'
import AdminTfidbTags from '../../Movie/AdminTags'
import { FaCaretDown, FaCaretUp } from 'react-icons/fa'

function PersonTags(props) {
  const { activeSection, section, handleSectionClick, rendeedPersondata } = props
  return (
    <div
      id={section}
      className={`accordion-item ${
        activeSection === section || activeSection === 'all' ? 'active' : ''
      }`}
    >
      <h2 className='accordion-header' id='headingFour'>
        <button
          className='accordion-button'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#collapseFour'
          aria-expanded={activeSection === section || activeSection === 'all'}
          aria-controls='collapseFour'
          onClick={() => handleSectionClick(section)}
          style={{ color: 'white' }}
        >
          <span>Tags</span>
          {activeSection === section || activeSection === 'all' ? <FaCaretUp /> : <FaCaretDown />}
        </button>
      </h2>
      <div
        id='collapseFour'
        className={`accordion-collapse collapse ${
          activeSection === section || activeSection === 'all' ? 'show' : ''
        }`}
        aria-labelledby='headingFour'
        data-bs-parent='#accordion'
      >
        {<TfidbTags movieData={rendeedPersondata} type={'person'} />}
        {<AdminTfidbTags movieData={rendeedPersondata} label={'Good'} type={'person'} />}
        {<AdminTfidbTags movieData={rendeedPersondata} label={'Bad'} type={'person'} />}
      </div>
    </div>
  )
}

export default PersonTags
